export default __webpack_public_path__ + "static/media/tw.903ec24b.jpg";